import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '#/components/ui/drawer';
import React from 'react';

import { SvgIconClose } from '../svg/icon-close';

export type DrawerTicketDescriptionProps = {
  trigger: React.ReactNode;
};

export const SiteDrawerTicketDescription = ({ trigger }: DrawerTicketDescriptionProps) => (
  <Drawer>
    <DrawerTrigger asChild>{trigger}</DrawerTrigger>
    <DrawerContent className="gap-6 pb-10">
      <DrawerHeader className="flex justify-between py-0 pr-4 pl-[16px] text-left md:mt-0 md:gap-4 md:px-4">
        <DrawerTitle className="!text-headline-m">株引換券とは</DrawerTitle>
        <DrawerDescription className="sr-only">株引換券とは</DrawerDescription>
        <DrawerClose asChild>
          <button type="button" aria-label="Close" className="relative outline-blue-500">
            <SvgIconClose width={24} height={24} className="text-grey-900 size-6 flex-none" aria-label="閉じる" />
          </button>
        </DrawerClose>
      </DrawerHeader>
      <div className="flex flex-col gap-6 overflow-y-scroll px-4">
        <p className="text-body-m">
          株引換券とは、サービスのご利用ごとに貯まる株交換に必要な電子チケットです。1枚=1円であり、株価に応じて交換に必要な株引換券の枚数が変わります。
        </p>
      </div>
    </DrawerContent>
  </Drawer>
);
